import useSWR from 'swr';
import { fetcher } from '../services/fetcher';

export interface SupportTicket {
  id: number;
  clientId?: number;
  reference: string;
  title: string;
  description?: string;
  statusId?: number;
  priority?: number;
  assignedToId?: number;
  createdAt: string;
}

export interface SupportTicketsResponse {
  data: SupportTicket[];
  total: number;
  page: number;
  limit: number;
}

export const useSupportTickets = (searchParams?: string, filter?: string) => {
  const queryParams = new URLSearchParams();
  if (searchParams) queryParams.append('searchParams', searchParams);
  if (filter) queryParams.append('filter', filter);
  const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';

  const { data, error, isLoading, mutate } = useSWR<SupportTicket[]>(
    `/support-ticket${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    tickets: data || [],
    total: data?.length || 0,
    isLoading,
    isError: error,
    mutate,
  };
};

export const useSupportTicket = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<SupportTicket>(
    id ? `/support-ticket/${id}` : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    ticket: data,
    isLoading,
    isError: error,
    mutate,
  };
};

